module.exports = __webpack_public_path__ + "static/image/history/pc/201908@3x.jpg?134cfa90";